import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import {useApi} from "../provider/ApiProvider";
import CompanyDialog from "../dialogs/CompanyDialog";
import {Button, Popconfirm} from "antd";
import {DeleteOutlined, EditFilled, FileExcelOutlined, PlusOutlined, RightOutlined,DownloadOutlined} from "@ant-design/icons";
import {Excel} from "antd-table-saveas-excel";


export default function CompaniesPage(){
    const columns = [

        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
        },

        // {
        //     title: 'İl',
        //     dataIndex: 'city',
        //     key: 'city',
        // },
        // {
        //     title: 'İlçe',
        //     dataIndex: 'district',
        //     key: 'district',
        // },

        {
            title: 'Ana Şirket',
            render: (record) => <span>{record?.Customer?.name}</span>
        },
        {
            title: 'Platform',
            render: (record) => <span>{record?.Platform?.name}</span>
        },
        {
            title: 'İşlemler',
            fixed: 'right',
            width: 220,
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id, record)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>
                    <Button onClick={() => editDialog(record)}>
                        <EditFilled />
                    </Button>

                    <Button onClick={() => addQrCode(record)}>
                        <DownloadOutlined />
                    </Button>

                </div>
            )
        }

    ];
    const columnsexcell = [

        {
            title: 'Adı',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Ana Şirket',
            dataIndex: ['Customer','name'],
            key:'Ana Şirket'
        },
        {
            title: 'Platform',
            dataIndex: ['Platform','name'],
            key: 'Platform'
        }


    ];

    const {api} = useApi();
    const [companies, setCompanies] = useState({totalCount: 0, items:[]});
    const [dialog, setDialog] = useState({open: false, data: null,type: null});

    useEffect(() => {
        load({skip: 0, max: 10000});
    }, [])

    async function load(params){
        await api.get('/companyRouter/company/all', params).then(resp => {
            console.log(resp)
            setCompanies({totalCount: resp.totalCount, items: resp.data});
        })
    }

    function addDialog(){
        setDialog({open: true, data: null,type : "company"});
    }
    function addQrCode(data){
        setDialog({open: true, data: data, type : "qr"});
    }

    function editDialog(data){
        setDialog({open: true, data: data, type : "company"});
    }

    function deleteRow(id, record){
        api.delete("/companyRouter/company/delete/" + id, record).then(resp => {
            load();
        }).finally(() => {

        })
    }
    async function onSearch(value){
        let filter = {
            search: value
        }
        load(filter);
    }
    function tableChange(filter){
        let newFilter = {
            skip: (filter.page - 1) * filter.perPage,
            max: filter.perPage
        }
        load(newFilter);
    }

    return (
        <LayoutComponent title={"Firmalar-Şubeler"} links={
            [
                {
                    title: 'Firma-Şube Listesi',
                    url: '/'
                },

            ]}
                         newButton={<>
                             <div>
                             <Button icon={<PlusOutlined />} onClick={() => addDialog()} type="primary" style={{marginRight: '10px'}}>Ekle</Button>

                             <Button
                                 type="primary"
                                 icon={<FileExcelOutlined />}
                                 onClick={() => {
                                     const excel = new Excel();
                                     excel
                                         .addSheet('test')
                                         .addColumns(columnsexcell)
                                         .addDataSource(companies.items)
                                         .saveAs('Firmalar.xlsx');
                                 }}
                             >
                                 Excel
                             </Button>
                             </div>
                         </>}
        >
            <TableComponent
                columns={columns}
                data={companies}
                search={true}
                onSearch={onSearch}
                clickRow={(data) => editDialog(data)}
                onChange={tableChange}
            />
            <CompanyDialog
                open={dialog.open}
                data={dialog.data}
                type={dialog.type}
                onChange={() => load()}
                onClose={() => setDialog({open: false, data: null,type:null})}
            />
        </LayoutComponent>
    )
}
